<h2 mat-dialog-title>Add Permissions</h2>

<mat-dialog-content class="mat-typography">
  <div class="lists-container">

    @if (!isLoading) {
      <div class="list-panel">
        <h3 class="list-title">Available</h3>
        <table
          mat-table
          [dataSource]="availableRoles"
          class="table"
          cdkDropList
          #availableList="cdkDropList"
          [id]="'availableList'"
          [cdkDropListData]="availableRoles"
          [cdkDropListConnectedTo]="['assignedList']"
          (cdkDropListDropped)="drop($event)"
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row"></td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Permission</th>
            <td mat-cell *matCellDef="let row">
              {{ row.name }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-draggable" cdkDrag></tr>
        </table>
      </div>

      <div class="list-panel">
        <h3 class="list-title">Assigned</h3>
        <table
          mat-table
          [dataSource]="assignedRoles"
          class="table"
          cdkDropList
          #assignedList="cdkDropList"
          [id]="'assignedList'"
          [cdkDropListData]="assignedRoles"
          [cdkDropListConnectedTo]="['availableList']"
          (cdkDropListDropped)="drop($event)"
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row"></td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Permission</th>
            <td mat-cell *matCellDef="let row">
              {{ row.name }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row-draggable" cdkDrag></tr>
        </table>
      </div>
    }@else{
      <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate" class="bright-spinner"> </mat-progress-spinner>
      </div>
    }
    
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="sendRoleList()">Accept</button>
</mat-dialog-actions>
